"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendArgsToWidget = exports.fetchCityfromPincode = exports.removeWidgetFromBody = exports.isBackdrop = exports.attachToWindow = exports.fetchHTML = exports.widgetNotPresent = exports.attachListener = exports.getWidgetUrl = void 0;
var clickstream_1 = require("@airtel-web/clickstream");
var AnalyticsInterface_1 = require("../common/AnalyticsInterface");
var commonUtils_1 = require("../common/commonUtils");
var AppConstant_1 = require("../constants/AppConstant");
var EventConstants_1 = require("../constants/EventConstants");
var sendEventBridge_1 = require("../eventUtils/sendEventBridge");
function getWidgetUrl(lob, pageName, requestorSource, visitorId, containerHeight, containerWidth, customUri, version, sessionId, dateString) {
    var urlParams = new URLSearchParams();
    if (lob && pageName && requestorSource) {
        urlParams.append(AppConstant_1.LOB, lob);
        urlParams.append(AppConstant_1.PAGE_NAME, pageName);
        urlParams.append(AppConstant_1.REQUESTOR_SOURCE, requestorSource);
        visitorId && urlParams.append(AppConstant_1.VISITOR_ID, visitorId);
        containerHeight && urlParams.append(AppConstant_1.CONTAINER_HEIGHT, containerHeight.toString());
        containerWidth && urlParams.append(AppConstant_1.CONTAINER_WIDTH, containerWidth.toString());
        version && urlParams.append(AppConstant_1.VERSION, version);
        sessionId && urlParams.append(AppConstant_1.SESSION_ID, sessionId);
        dateString && urlParams.append(AppConstant_1.DATE, dateString);
        if (customUri) {
            return customUri + urlParams.toString();
        }
    }
    return AppConstant_1.OMNIWIDGET_PROD_URI + urlParams.toString();
}
exports.getWidgetUrl = getWidgetUrl;
;
function attachListener(cb) {
    var eventHandler = function (event) {
        if (event.data && event.data.eventName && event.data.trigger != 'Heartbeat') {
            cb === null || cb === void 0 ? void 0 : cb(event.data.eventName, event.data);
        }
    };
    window.removeEventListener('message', eventHandler, true);
    window.addEventListener('message', eventHandler, true);
}
exports.attachListener = attachListener;
function widgetNotPresent() {
    var nativeEl = document.getElementById("react-native-web-app");
    if (!nativeEl && (nativeEl === null || nativeEl === void 0 ? void 0 : nativeEl.childNodes.length) <= 0) {
        removeWidgetFromBody();
        return false;
    }
    ;
    return true;
}
exports.widgetNotPresent = widgetNotPresent;
function fetchHTML(URL) {
    if (URL === void 0) { URL = AppConstant_1.OMNIWIDGET_PROD_URI; }
    fetch(URL).then(function (res) { return res.text(); }).then(function (res) {
        var executableElement = document.createElement('body');
        executableElement.innerHTML = res;
        eval(executableElement.querySelector("script").innerHTML);
    }).catch(function (error) {
        (0, AnalyticsInterface_1.sendClickstreamLog)({
            eventLabel: AppConstant_1.ERROR_CONSTS.FETCH_FAILED,
            eventValue: error
        });
    });
}
exports.fetchHTML = fetchHTML;
function attachToWindow(props) {
    delete window['containerData'];
    window['containerData'] = props;
}
exports.attachToWindow = attachToWindow;
function isBackdrop(enabled, eventData) {
    var widget = document.getElementById('widget-mask');
    var doc = document.getElementById("container-root");
    var app = document.getElementById("react-native-web-app");
    if ((0, commonUtils_1.isEmpty)(doc)) {
        document.body.removeChild(app);
        document.body.removeChild(widget);
        return;
    }
    if (enabled) {
        doc.innerHTML = "";
        document.body.appendChild(widget);
        document.body.appendChild(app);
        addStyle(app, "backdrop", eventData === null || eventData === void 0 ? void 0 : eventData.iframeStyleId);
        addStyle(widget, "maskStyle", eventData === null || eventData === void 0 ? void 0 : eventData.maskStyleId);
    }
    else if (!enabled && !(doc === null || doc === void 0 ? void 0 : doc.hasChildNodes())) {
        removeStyle(app, "backdrop", true);
        removeStyle(widget, "maskStyle", false);
        doc.appendChild(widget);
        doc.appendChild(app);
    }
}
exports.isBackdrop = isBackdrop;
function removeWidgetFromBody() {
    var _a, _b;
    sessionStorage.removeItem('persist:omniWidgetPersistedStore');
    sessionStorage.removeItem('aa-omni-serviceability');
    (_a = document.getElementById('react-native-web-app')) === null || _a === void 0 ? void 0 : _a.remove();
    (_b = document.getElementById('widget-mask')) === null || _b === void 0 ? void 0 : _b.remove();
}
exports.removeWidgetFromBody = removeWidgetFromBody;
function addStyle(element, styleName, styleObj) {
    element === null || element === void 0 ? void 0 : element.classList.add(styleName);
    if ((0, commonUtils_1.isNotEmpty)(styleObj))
        for (var property in styleObj) {
            element.style[property] = styleObj[property];
        }
}
function removeStyle(element, styleName, addDisplay) {
    element === null || element === void 0 ? void 0 : element.classList.remove(styleName);
    element.removeAttribute('style');
    if (addDisplay)
        element.style.display = 'block';
}
function fetchCityfromPincode(data, props) {
    return __awaiter(this, void 0, void 0, function () {
        var requestId, request;
        return __generator(this, function (_a) {
            requestId = (0, clickstream_1.create_UUID)();
            request = {
                requestId: requestId,
                visitorId: props.visitorId,
                lob: props === null || props === void 0 ? void 0 : props.lob,
                requestorSource: props === null || props === void 0 ? void 0 : props.requestorSource,
                pageName: props.pageName,
                city: data === null || data === void 0 ? void 0 : data.city,
                pincode: data === null || data === void 0 ? void 0 : data.pinCode,
                latitude: data === null || data === void 0 ? void 0 : data.latitude,
                longitude: data === null || data === void 0 ? void 0 : data.longitude,
                addressString: data === null || data === void 0 ? void 0 : data.addressString,
                dropdownMainLabel: data === null || data === void 0 ? void 0 : data.dropdownMainLabel,
                dropdownSecondaryLabel: data === null || data === void 0 ? void 0 : data.dropdownSecondaryLabel
            };
            if (request.lob === "DTH") {
                request['serviceName'] = AppConstant_1.DTH_SERVICE_NAME;
            }
            fetch(AppConstant_1.FETCH_CITY_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(request)
            }).then(function (response) { return response.json(); })
                .then(function (response) {
                var _a;
                if (response.responseStatus.responseCode == AppConstant_1.ERROR_CONSTS.ERROR_CODE) {
                    (0, AnalyticsInterface_1.sendClickstreamLog)({
                        eventLabel: AppConstant_1.ERROR_CONSTS.API_FAILURE,
                        eventValue: response.errorDetails.errorMessage,
                        error: response.errorDetails.backendErrorMessage
                    });
                }
                else {
                    if ((0, commonUtils_1.isNotEmpty)((_a = response.validatedAddress) === null || _a === void 0 ? void 0 : _a.reason)) {
                        (0, AnalyticsInterface_1.sendClickstreamLog)({
                            eventLabel: EventConstants_1.UPDATED_CITY,
                            eventValue: response.validatedAddress.reason
                        });
                    }
                    (0, sendEventBridge_1.sendToWidget)({
                        eventName: EventConstants_1.EVENTS.AUTO_FILL,
                        eventType: EventConstants_1.EVENTS_TYPE.AUTO_FILL,
                        savedAddress: response.validatedAddress,
                        pincodeDetails: response.pincodeDetails
                    });
                }
            }).catch(function (error) {
                (0, AnalyticsInterface_1.sendClickstreamLog)({
                    eventLabel: AppConstant_1.ERROR_CONSTS.API_FAILURE,
                    eventValue: error
                });
            });
            return [2 /*return*/];
        });
    });
}
exports.fetchCityfromPincode = fetchCityfromPincode;
function sendArgsToWidget(args) {
    (0, sendEventBridge_1.sendToWidget)({
        eventName: EventConstants_1.EVENTS.SEND_PROPS,
        eventType: EventConstants_1.EVENTS_TYPE.PROPS,
        data: args
    });
}
exports.sendArgsToWidget = sendArgsToWidget;
